import API from "../../api/api";
import React, { Component } from "react";
import { Link } from "react-router-dom";

import "../../styles/css/responsive.css";
import "../../styles/css/dashboard/dashboard.css";
import { Container, Row, Col } from "bootstrap-4-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import ProjectCard from "../../components/ProjectCards/ProjectCard";
import TabComponent from "../Dashboard/Tab";

import {
  Wrapper,
  ActivityFeed,
  DashboardHeader,
  FinancialStats,
  JobStats,
  UserStats,
} from "../../components";

const userRole = localStorage.getItem("userRole");

class AllJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activityFeed: "",
      job: "",
      finance: "",
      user: "",
      isDashboardLoading: true,

      detailsData: [],
      jobData: [],

      // searchParams
      searchKey: "",
      surveyType: "",
    };
  }

  componentDidMount() {
    // API.get("dashboard/admin")
    //   .then((res) => {
    //     console.log(res);
    //     const dashboardData = res.data.response;
    //     this.setState({
    //       activityFeed: dashboardData.activity_feed,
    //       job: dashboardData.job,
    //       finance: dashboardData.finance,
    //       user: dashboardData.user,
    //       isDashboardLoading: false,
    //     });
    //   })
    //   .catch((err) => {
    //     console.log("AXIOS ERROR: ", err);
    //   });

    this.getJobs();
  }
  async searchJobs(key, type) {
    await this.setState({
      searchKey: key,
      surveyType: type,
    });
    await this.getJobs();
  }

  async getJobs() {
    await this.setState({
      isDashboardLoading: true,
    });
    const url =
      userRole === "Title Company Admin" || userRole === "Title Company User"
        ? "dashboard/title"
        : userRole === "Surveyor" ||
          userRole === "Surveyor User" ||
          userRole === "Admin"
        ? "dashboard/survey"
        : null;

    await API.get(`job/all`)
      .then((res) => {
        console.log(res);
        this.setState({
          detailsData: res.data.response.card && res.data.response.card,
          jobData: res.data.response.jobs && res.data.response.jobs,
          isDashboardLoading: false,
        });
      })
      .catch((err) => {
        this.setState({ isDashboardLoading: true });
        console.log("AXIOS ERROR: ", err);
      });
  }

  render() {
    // const { isDashboardLoading } = this.state;
    const { detailsData, jobData, isDashboardLoading } = this.state;
    // console.log(this.state);

    return (
      <Wrapper>
        <Container className="breadCrubmContainerDashboard">
          <div className="breadCrumb">
            <Link to="/" className="prevLinks">
              Dashboard
            </Link>
            <span>&nbsp;&gt;&nbsp;</span>
            <span className="currLink">All Jobs</span>
          </div>
        </Container>

        {isDashboardLoading ? (
          <div className="preloader">
            <CircularProgress className="preloaderCircle" />
          </div>
        ) : (
          <div className="">
            <Container>
              <Row>
                <Col col="sm-12 md-12 lg-12">
                  <div className="headerCardRoot">
                    <div className="headerCardMain cardHeading">
                      <div className="headerCardTitle">
                        <span>All Jobs</span>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col col="sm-12 md-12 lg-12">
                  <TabComponent jobData={jobData} />
                  {/* <div>
                    {jobData &&
                      jobData.map((job) => {
                        return <ProjectCard key={job.id} jobData={job} />;
                      })}
                  </div>{" "} */}
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </Wrapper>
    );
  }
}

export default AllJobs;



// WEBPACK FOOTER //
// ./src/pages/Jobs/AllJobs.js